export interface BatchReserveCancelListRequest {
  cancelDateFrom: string
  cancelDateTo: string
  branchType: string
  branchCode: string
  hasReceiveWaiting: boolean
  hasReturnWaiting: boolean
  reserveCancelReason: string
  batchType: string
}

export function BatchReserveCancelListRequestToJSON(
  value: BatchReserveCancelListRequest
): any {
  return {
    cancel_date_from: value.cancelDateFrom,
    cancel_date_to: value.cancelDateTo,
    branch_type: value.branchType,
    branch_code: value.branchCode,
    has_receive_waiting: value.hasReceiveWaiting,
    has_return_waiting: value.hasReturnWaiting,
    reserve_cancel_reason: value.reserveCancelReason,
    batch_type: value.batchType
  }
}
